export const uppercaseFirstLetter = (text: string) => {
  const stringType = 'stringType';
  if (typeof text === typeof stringType) {
    return text[0].toUpperCase() + text.slice(1);
  } else {
    return text;
  }
};
